import { createAsyncAction } from 'services/actionConfigs';
import { IApiGetDemoDataParam, ILoginRequest, ILoginResponse } from '../interfaces/api';
import { PREFIX_ACTIONS } from './constants';

const getDemoData = createAsyncAction<IApiGetDemoDataParam>(PREFIX_ACTIONS + 'getDemoData');
const login = createAsyncAction<ILoginRequest, ILoginResponse>(PREFIX_ACTIONS + 'login');
const logout = createAsyncAction<void>(PREFIX_ACTIONS + 'logout');

const authActions = {
  getDemoData,
  login,
  logout,
};

export default authActions;

